import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import "core-js/modules/web.dom-collections.iterator.js";
import { observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
import { Trans } from "react-i18next";
import { useTheme } from "styled-components";
import Box from "../Styled/Box";
import { RawButton } from "../Styled/Button";
import Icon, { StyledIcon } from "../Styled/Icon";
import Text, { TextSpan } from "../Styled/Text";
import { useViewState } from "./Context";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DragDropNotification = observer(_ref => {
  let {
    uploadedFiles
  } = _ref;
  const theme = useTheme();
  const viewState = useViewState();
  const [showNotification, setShowNotification] = useState(false);
  const notificationTimeoutRef = useRef(null);
  useEffect(() => {
    if (notificationTimeoutRef.current) {
      clearTimeout(notificationTimeoutRef.current);
    }
    // show notification, restart timer
    setShowNotification(true);
    // initialise new time out
    notificationTimeoutRef.current = setTimeout(() => {
      setShowNotification(false);
    }, 5000);
    return () => {
      if (notificationTimeoutRef.current) {
        clearTimeout(notificationTimeoutRef.current);
      }
    };
  }, [uploadedFiles]);
  const handleHover = () => {
    // reset timer on hover
    if (notificationTimeoutRef.current) {
      clearTimeout(notificationTimeoutRef.current);
    }
  };
  const handleMouseLeave = () => {
    notificationTimeoutRef.current = setTimeout(() => {
      setShowNotification(false);
    }, 4000);
  };
  const handleClick = () => {
    viewState.openUserData();
  };
  const fileNames = uploadedFiles.join(",");
  return /*#__PURE__*/_jsxs(_StyledRawButton, {
    onMouseEnter: handleHover,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick,
    $_css: showNotification && fileNames.length > 0 && "right: 100px;",
    children: [/*#__PURE__*/_jsx(_StyledBox, {
      paddedRatio: 3,
      $_css2: theme.colorPrimary,
      children: /*#__PURE__*/_jsx(StyledIcon, {
        glyph: Icon.GLYPHS.upload,
        light: true,
        styledWidth: "35px",
        opacity: 0.9
      })
    }), /*#__PURE__*/_jsx(_StyledBox2, {
      paddedRatio: 3,
      displayInlineBlock: true,
      styledWidth: "210px",
      $_css3: theme.dark,
      children: /*#__PURE__*/_jsx(Text, {
        extraLarge: true,
        breakWord: true,
        children: /*#__PURE__*/_jsxs(Trans, {
          i18nKey: "dragDrop.notification",
          count: uploadedFiles.length,
          children: [/*#__PURE__*/_jsxs(TextSpan, {
            bold: true,
            noFontSize: true,
            children: ["\"", {
              fileNames
            }, "\""]
          }), {
            count: uploadedFiles.length
          }, " been added to", " ", /*#__PURE__*/_jsx(TextSpan, {
            primary: true,
            noFontSize: true,
            children: "My data"
          })]
        })
      })
    })]
  });
});
DragDropNotification.displayName = "DragDropNotification";
export default DragDropNotification;
var _StyledRawButton = _styled(RawButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          display: flex;\n          background: #ffffff;\n          position: fixed;\n          right: -280px;\n          top: 80px;\n          z-index: 9;\n          transition: all 0.25s;\n          transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n          ", ";\n        "])), p => p.$_css);
var _StyledBox = _styled2(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            background: ", ";\n          "])), p => p.$_css2);
var _StyledBox2 = _styled3(Box).withConfig({
  displayName: "DragDropNotification___StyledBox2",
  componentId: "sc-6n2gqe-0"
})(["color:", ";"], p => p.$_css3);